import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7814c810"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ExternalTeacherStatistics" }
const _hoisted_2 = { class: "pagecontent" }
const _hoisted_3 = { class: "timetage" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { useStore } from "@/store";
import { initEmptyParam } from "@/hooks/useInitParam";
import dayjs from 'dayjs'
import { getListData } from "@/service/main/system";
import WatermarkCanvas from '@/components/Watermark.vue';
import { getPageListData } from '@/service/main/system'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalTeacherStatistics',
  setup(__props) {

const ot = ref('')//操作时间
const qt = ref('')//查询时间
//获取查询时间和操作时间
const getTimeInfo = async (queryParam) => {
  let res = await getPageListData(
    '/main/externalTeacherStatistics/queryByCondition',
    queryParam
  )
  ot.value = res.operateTime
  qt.value = res.queryTimeSlot
  console.log('获取时间信息', ot.value, qt.value)

}
const timeStr = ref('')

initEmptyParam()
const store = useStore()

const getChannelList = async () => {
  let channelData = await getListData('/main/customerChannel/queryAllChannel', {})
  const channelItem = searchFormConfig.formItems.find(item => item.field === 'channelName')
  channelItem!.options = channelData.map((item: any) => {
    return { title: item, value: item }
  })
}
getChannelList()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryMainThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'thirdParty')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return { title: item, value: item }
  })
}
getThirdPartyList()

const queryParam = {
  timeSlot: [
    dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)
// getTimeInfo(queryParam)
const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  console.log('store.commit()', queryInfo)
  pageContentRef.value?.getPageData(queryInfo)
}

const resetCb = () => {
  return queryParam
}
const changeTime = (val: any) => {
  console.log('子组件时间信息传值', val)
  timeStr.value = val
}
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WatermarkCanvas),
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(timeStr.value), 1),
      _createVNode(_component_PageContent, {
        ref_key: "pageContentRef",
        ref: pageContentRef,
        contentTableConfig: _unref(contentTableConfig),
        pageName: "externalTeacherStatistics",
        onSortChange: handleSortChange,
        onChangeTime: changeTime
      }, null, 8, ["contentTableConfig"])
    ])
  ]))
}
}

})